(function ($) {

// Filtration price
$(document).gp_ready(function () {

    // Filtration FE
    $(".filtration__range-input").focusout(function () {
        $(this).find(".filtration__range-label").css("opacity", "1");
    })
    $(".filtration__range-input").focusin(function () {
        $(this).find(".filtration__range-label").css("opacity", "0");
    })

    let $price_slider = []
    $(".price-slider").each(function () {
        var $myslider = $(this);
        $myslider.bootstrapSlider();

        $myslider.on("change", function () {

            var value = $myslider.bootstrapSlider('getValue')
            for (var i = 0; i < value.length; ++i) {
                var $input = $("input.sliderValue[data-index=" + i + "]");
                $input.val(value[i]);
                $input.parent().find(".filtration__range-label").html(value[i] + "<span> Kč</span>");
            }

            // Sync values with sidebar
            $price_slider.forEach((slider) => {
                slider.bootstrapSlider("setValue", value)
            })

        });

        // change value of range when change
        $(this).closest(".filtration__range").find("input.sliderValue").change(function () {

            let $range = $(this).closest(".filtration__range")

            // Set min and max number
            let max = parseInt($(this).attr('max'));
            let min = parseInt($(this).attr('min'));

            // Validate input
            let from = parseInt($range.find(".sliderValue[data-index='0']").val())
            let to = parseInt($range.find(".sliderValue[data-index='1']").val())

            if (from > to) {
                to = from + 1
            }

            if (from < min) {
                from = min
            }

            if (to > max) {
                to = max
            }

            $myslider.bootstrapSlider('setValue', [from, to]);
            $myslider.trigger("change")

        });

        $price_slider.push($myslider)

    });

});

})(jQuery);